import { Vue, Component, Prop, Emit, Watch, Ref } from 'vue-property-decorator'
import './index.less'

import {
  OrderProcessMaterialVO,
  MaterialAssignRecordServiceProxy,
  AssignMaterialDTO,

} from '@/service-proxies/app-v2/coproduction.service-proxies'

const materialAssignRecordServiceProxy = new MaterialAssignRecordServiceProxy()
@Component
export default class MaterialEdit extends Vue {
  // 物料需求清单
  @Prop({ default: {} }) readonly orderProcess: OrderProcessMaterialVO
  @Prop({default: null}) isAssign: true 
  @Prop({default: null}) visible: false
  planId = ''
  loading = false
  tableData = []
  // columns = []
  selectedRowIndex = 0
  selectedRowKeys = []
  tableScrollWidth = 1200
  currentSelected = { id: '' }
  num = 1
  get title () {
    return this.isAssign ? '编辑派料数量' : '编辑退料数量'
  }
  get numTitle () {
    return this.isAssign ? 'page_plan_material_distribution_quantity' : 'page_material_quantity_of_returned_materials'
  }
  get columns() { 
    let column={
      materialCode: 'page_product_materialCode',
      materialName: 'page_business_material_name',
      standardModel: 'page_material_check_standardModel',
      unit: 'page_material_check_unit',
      orderCode: 'page_plan_order_no',
      processName: 'page_plan_craft_name',
      requireNum: 'page_plan_demand_quantity',
      assignedNum: 'page_plan_assigned_quantity',
      numNotAssigned: 'page_material_demand_undelivered_quantity',
    }
    let temp = []
    for(let key in column){
      temp.push({
        title: this.$t(column[key]),
        key: key,
        dataIndex: key,
        width: 100,
        ellipsis: true
      })
    }
    return temp
  }

  handleOk() {
    if (!this.num) {
      this.$message.error('数量不能为空且必须为正整数！')
      return
    }
    const param = new AssignMaterialDTO({
      materialCode: this.orderProcess.materialCode,
      materialName: this.orderProcess.materialName,
      number: this.num,
      orderId: this.orderProcess.orderId,
      orderMaterialId: this.orderProcess.orderMaterialId,
      orderProcessId: this.orderProcess.id,
      processCode: this.orderProcess.processName,
      processName: this.orderProcess.processName,
    })
    if (this.isAssign) {
      materialAssignRecordServiceProxy.assignMaterial(param).then(res => {
        this.success()
      })
    } else {
      materialAssignRecordServiceProxy.returnMaterial(param).then(res => {
        this.success()
      })
    }
  }

  success() {
    this.$message.info(this.$t('page_mdc_setting_edit_success'))
    this.handleCancel(true)
  }
  handleCancel(flag) {
    this.num = 1
    this.$emit('cancel', flag)
  }
  changeNum(value) {
    this.num = value
  }
  render() {
    return (
      <a-modal
        title={this.title}
        visible={this.visible}
        onOk={() => this.handleOk()}
        maskClosable={false}
        onCancel={() => this.handleCancel(false)}
      > 
      <a-form label-col={{ span: 7 }} wrapper-col={{ span: 14 }}>
        <a-form-item class="flex" label={this.$t('page_plan_order_no')}>
          <div>{this.orderProcess.orderCode}</div>
        </a-form-item>
        <a-form-item  label={this.$t('page_process_name')}>
          <div>{this.orderProcess.processName}</div>
        </a-form-item>
        <a-form-item label={this.$t('page_business_material_name')}>
          <div>{this.orderProcess.materialName}</div>
        </a-form-item>
        <a-form-item label={this.$t('page_material_warehousing_material_code')}>
          <div>{this.orderProcess.materialCode}</div>
        </a-form-item>
        <a-form-item label={this.$t(this.numTitle) + '：'}>
          <a-input-number value={this.num} min={1}  precision={0} onChange={this.changeNum}></a-input-number>
        </a-form-item>
      </a-form>
      </a-modal>
    )
  }
}
